var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomepage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18 18h-4v7h4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.4201 14.18-7.71-7.87999c-.0929-.09373-.2035-.16812-.3254-.21889s-.2526-.07691-.3846-.07691-.2627.02614-.3846.07691c-.1218.05077-.2324.12516-.3254.21889l-7.70998 7.88999c-.18657.1881-.33391.4113-.43348.6568-.09956.2455-.14937.5083-.14652.7732v8.38c-.00078.5119.19477 1.0046.54637 1.3767s.83249.5952 1.34363.6233h3.10998v-9c0-.2652.1054-.5196.2929-.7071s.4419-.2929.7071-.2929h6c.2652 0 .5196.1054.7071.2929.1876.1875.2929.4419.2929.7071v9h3.11c.5112-.0281.992-.2512 1.3436-.6233s.5472-.8648.5464-1.3767v-8.38c.0008-.5371-.2072-1.0534-.58-1.44z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepage);
export default __webpack_public_path__ + "static/media/homepage.aae29e76e8aeda171f7197d5364e2a3b.svg";
export { ForwardRef as ReactComponent };